import { render, staticRenderFns } from "./ConsultHubStatisticPage.vue?vue&type=template&id=bd0638c6"
import script from "./ConsultHubStatisticPage.vue?vue&type=script&lang=ts"
export * from "./ConsultHubStatisticPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultHubStatisticPage.vue?vue&type=style&index=0&id=bd0638c6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports